/**
 * Signs the browser in with a Telegram payload.
 *
 * Mirrors `useAuthStore.login` step for step, so both paths hold the access token and
 * the cached identity the same way: drop every cached response before the new identity
 * can read one, keep the access token in memory only, then load `/api/auth/me/`.
 */
import { authApi, type TelegramWidgetUser } from "@/api/auth";
import { queryClient } from "@/app/queryClient";
import { apiRequest } from "@/lib/api";
import { writeAccessToken } from "@/lib/tokens";
import { useAuthStore, type AuthUser } from "@/store/auth";

/** Resolves when the session is established. Rejects with `ApiError` on refusal. */
export async function signInWithTelegram(payload: TelegramWidgetUser): Promise<void> {
  const tokens = await authApi.telegramSignIn(payload);
  queryClient.clear();
  writeAccessToken(tokens.access);
  const user = await apiRequest<AuthUser>("/api/auth/me/");
  useAuthStore.setState({ user, status: "authenticated" });
}
